module.exports = __webpack_public_path__ + "static/img/Dion-Teaupa.e275e9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dion-Teaupa.jpg
// module id = PuA8
// module chunks = 0